import React from "react";

import { Alert } from "clearsense-ui/components";

const MultiDeleteAlert = ({ isOpen, close, rowCount, submit }) => (
  <Alert
    isOpen={isOpen}
    onClose={close}
    submitButtonLabel="Delete"
    title="Delete connections?"
    message={`Are you sure you want to delete these ${rowCount} connection${
      rowCount > 1 ? "s" : ""
    }?`}
    onSubmit={submit}
  />
);

export default MultiDeleteAlert;
